import {FETCH_TIENDAS, FETCH_TIENDAS_ERROR, FETCH_TIENDAS_SUCCESS} from "../actions/catalogos/tiendasAction";

const initialState = {
    loading: true,
    tiendas: [],
    error: ''
};

const tiendasReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TIENDAS:
            return {
                ...state,
                loading: true
            };
        case FETCH_TIENDAS_SUCCESS:
            return {
                loading: false,
                tiendas: action.payload,
                error: ''
            };
        case FETCH_TIENDAS_ERROR:
            return {
                loading: false,
                tiendas: [],
                error: action.payload
            };
        default:
            return state;
    }
};

export default tiendasReducer;